/**
 * TeamSystem Impact - Sync Available Years
 * Allinea la lista degli anni di rendicontazione mostrata nel selettore
 * con quella autoritativa sul server (setup DMA dell'azienda).
 *
 * Prima di questa logica la lista viveva solo nel localStorage del browser,
 * per cui ogni utente vedeva anni diversi (residui di test, anni mai
 * sincronizzati ecc.). Qui la rileggiamo dal server a ogni avvio dell'app.
 */

import { useEffect } from 'react';
import { reportingYearsApi } from '../api/reportingYears.api';
import { useWorkingYearStore } from './workingYearStore';

export function useSyncAvailableYears() {
  const setAvailableYears = useWorkingYearStore((s) => s.setAvailableYears);

  useEffect(() => {
    let cancelled = false;

    // Gli anni arrivano dall'unione lato server di DMA + configurazione anno
    // (data capture) + engagement, così il selettore mostra ogni anno in cui
    // si sta effettivamente lavorando, non solo quelli con un setup DMA.
    reportingYearsApi
      .list()
      .then((years) => {
        if (cancelled) return;
        setAvailableYears(years);
      })
      .catch(() => {
        // In caso di errore di rete lasciamo la lista locale invariata:
        // meglio un selettore con i dati vecchi che uno vuoto.
        //
        // Il flag si alza lo stesso: significa «il server ha risposto, in un
        // modo o nell'altro». Se la chiamata fallisce, `setAvailableYears` non
        // gira mai, quindi da qui in poi NIENTE puo' piu' spostare l'anno — e
        // chi aspetta questo flag (`useYearFromUrl`) puo' agire sulla lista
        // locale senza il rischio di essere scavalcato mezzo secondo dopo.
        if (!cancelled) useWorkingYearStore.setState({ yearsSynced: true });
      });

    return () => {
      cancelled = true;
    };
  }, [setAvailableYears]);
}
